'use client';

import React, { useEffect, memo } from 'react';
import { useAnalytics } from '@lib/segment';

interface PageImpressionProps {
  children?: React.ReactNode;
  displayMode?: string;
  entityName: string;
  eventType?: string;
  payloadOverride?: Record<string, unknown>;
  segmentEventName?: string;
}

const PageImpression: React.FC<PageImpressionProps> = ({
  children,
  eventType = 'page_impression',
  entityName,
  segmentEventName = entityName,
  payloadOverride,
}) => {
  const { segmentPage } = useAnalytics();
  useEffect(
    () => {
      segmentPage(segmentEventName, payloadOverride);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
    [eventType, entityName, JSON.stringify(payloadOverride)],
  );

  return children || [];
};

export default memo(PageImpression);
